import React from 'react';
import XRaySlideoutBannerNormalSrc from './XRaySlideoutBanner_normal.png';
import XRaySlideoutBannerWhiteSrc from './XRaySlideoutBanner_white.png';

export const XRaySlideoutBanner = ({
  textColor = 'normal',
  ...props
}: {
  textColor?: 'white' | 'normal';
} & React.ComponentProps<'img'>) => {
  switch (textColor) {
    case 'normal':
      return <img {...props} src={XRaySlideoutBannerNormalSrc} />;
    case 'white':
      return <img {...props} src={XRaySlideoutBannerWhiteSrc} />;
    default:
      return <></>;
  }
};
